import { SnapchatRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = Object.fromEntries(
  Object.keys(SnapchatRecommendationKey).map((k) => [
    SnapchatRecommendationKey[k],
    {
      ...manualRecommendation,
      gatherStageDefs: [
        manualRecommendation.generateManualRecommendationGatherStageDef(
          SnapchatRecommendationKey[k],
        ),
      ],
    },
  ]),
)

export const snapchatRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => [],
  getAdditionalFullGatherStageDefs: () => [],
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: () => true,
}
